"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wizard = exports.methods = exports.initialState = exports.usergroupInviteReducer = exports.usergroupListReducer = void 0;
const sok_types_1 = require("@caddigital/sok-types");
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const Actions = require("../../actionTypes/project/wizard");
const _usergroupListReducer = require("../../modules/usergroup/list/reducers");
const _usergroupInviteReducer = require("../../modules/usergroup/invite/reducers");
exports.usergroupListReducer = _usergroupListReducer.default('project/wizard');
exports.usergroupInviteReducer = _usergroupInviteReducer.default('project/wizard');
//#region INITIAL STATE
const initialMeta = {
    name: '',
    type: 'text',
    bitField: sok_types_1.CustomMeta.EDITABLE | sok_types_1.CustomMeta.FILES_LIST,
    required: false,
    identifier: '',
    editable: true,
    hideOnFileList: false,
    mandatory: false,
    order: 0
};
const createEditInitialState = {
    status: 'NONE',
    type: 'NONE',
    name: '',
    id: -1
};
const billingInformationModalInitialState = {
    isOpen: false,
    fetchingCustomerStatus: 'STANDBY',
    customers: [],
    selectedCustomer: undefined,
    fetchingProjectStatus: 'STANDBY',
    projects: []
};
exports.initialState = {
    wizardStep: 0,
    step1: {
        id: -1,
        uuid: null,
        customer: null,
        projectName: '',
        salesRepresentive: undefined,
        customerSalesRepresentative: undefined,
        customerSalesRepresentativeStatus: 'STANDBY',
        printProviders: [],
        conversionService: 'Vektorio',
        template: false,
        billingInformations: [],
        notes: '',
        notifyFollowing: [],
        projectAdmins: [],
        status: 'INITIAL',
        projectId: null,
        projectStatus: null,
        projectType: null,
        description: '',
        normalUserGroups: [],
        project: { status: 'STANDBY' },
        author: undefined,
        type: 'DRAFT_PROJECT',
        selectedPrintProvider: undefined,
        featuresStatus: 'STANDBY',
        features: [],
        featuresError: undefined
    },
    customers: {
        status: 'STANDBY'
    },
    step3: Object.assign(Object.assign({}, exports.usergroupListReducer.initialState), { invite: Object.assign({}, exports.usergroupInviteReducer.initialState), modal: Object.assign({}, createEditInitialState) }),
    step4: {
        schemaId: null,
        metaMap: {},
        editStatus: 'STANDBY',
        listStatus: 'STANDBY',
        deleteStatus: 'STANDBY'
    },
    step5: {
        projectId: null
    },
    metaModal: {
        isOpen: 'NONE',
        isSaving: 'STANDBY',
        values: Object.assign({}, initialMeta),
        option: ''
    },
    fetchStatus: 'STANDBY',
    isSaving: 'STANDBY',
    error: '',
    types: [
        { value: 'text', name: 'Text' },
        { value: 'day', name: 'Day' },
        { value: 'datetime', name: 'Datetime' },
        { value: 'select', name: 'Drop Down' },
        { value: 'dependant-select', name: 'Dependant Drop Down' },
        { value: 'checkbox', name: 'Checkbox' }
    ],
    printProviders: [],
    billingInformations: Object.assign({}, billingInformationModalInitialState)
};
//#endregion
//#region LENS
const step1Lens = monocle.Lens.fromProp('step1');
const changedCustomerLens = monocle.Lens.fromPath(['step1', 'customer']);
const customersLens = monocle.Lens.fromProp('customers');
const wizardStepLens = monocle.Lens.fromProp('wizardStep');
const step3Lens = monocle.Lens.fromProp('step3');
const step4Lens = monocle.Lens.fromProp('step4');
const savingLens = monocle.Lens.fromProp('isSaving');
const fetchStatusLens = monocle.Lens.fromProp('fetchStatus');
const metaLens = monocle.Lens.fromProp('metaModal');
const metaModalStatusLens = new monocle.Setter((set) => (state) => {
    const isOpen = set(state.isOpen);
    if (isOpen === 'NONE') {
        return {
            isOpen: 'NONE',
            isSaving: 'STANDBY',
            values: Object.assign({}, initialMeta),
            option: ''
        };
    }
    return Object.assign(Object.assign({}, state), { isOpen: isOpen });
});
const inviteLens = monocle.Lens.fromProp('invite');
const customersStatusLens = new monocle.Setter((set) => (state) => {
    const status = set(state.status);
    if (status === 'STANDBY') {
        return {
            status
        };
    }
    return {
        status,
        customers: []
    };
});
const customersValuesLens = new monocle.Setter((set) => (state) => {
    if (state.status === 'STANDBY') {
        return state;
    }
    return {
        status: state.status,
        customers: set(state.customers)
    };
});
const metaModalValuesLens = new monocle.Optional((state) => {
    if (state.isOpen !== 'NONE') {
        return fp.option.some(state.values);
    }
    return fp.option.none;
}, (values) => (state) => {
    if (state.isOpen !== 'NONE') {
        return Object.assign(Object.assign({}, state), { values });
    }
    return state;
});
const metaModalSelectedValueLens = new monocle.Optional((state) => {
    if (state.isOpen !== 'NONE') {
        return fp.option.some(state.option);
    }
    return fp.option.none;
}, (option) => (state) => {
    if (state.isOpen !== 'NONE') {
        return Object.assign(Object.assign({}, state), { option });
    }
    return state;
});
const optionsValuesLens = new monocle.Optional((metadata) => {
    if (metadata.options !== undefined) {
        return fp.option.some(metadata.options);
    }
    else {
        return fp.option.some([]);
    }
}, (options) => (metadata) => {
    return Object.assign(Object.assign({}, metadata), { options: options });
});
const step1StatusLens = monocle.Lens.fromProp('status');
const step1ProjectLens = monocle.Lens.fromProp('project');
const updateFieldLens = (key, value) => monocle.Lens.fromProp(key).set(value);
const setMetaField = (key, value) => monocle.Lens.fromProp(key).set(value);
const metaSchemaIdLens = monocle.Lens.fromProp('schemaId');
const metaListLens = monocle.Lens.fromProp('metaMap');
const metaListEditStatusLens = monocle.Lens.fromProp('editStatus');
const metaListStatusLens = monocle.Lens.fromProp('listStatus');
const metaDeleteStatusLens = monocle.Lens.fromProp('deleteStatus');
const step1ErrorsLens = new monocle.Optional((a) => (a.status === 'ERROR' ? fp.option.some(a.errors) : fp.option.none), (a) => (s) => (s.status === 'ERROR' ? Object.assign(Object.assign({}, s), { errors: a }) : s));
const step3ModalLens = monocle.Lens.fromProp('modal');
const step3ModalStatusLens = monocle.Lens.fromPath(['modal', 'status']);
const step3ModalNameLens = monocle.Lens.fromPath(['modal', 'name']);
const step3ModalIdLens = monocle.Lens.fromPath(['modal', 'id']);
const step3ModalTypeLens = monocle.Lens.fromPath(['modal', 'type']);
const billingInformationsLens = monocle.Lens.fromProp('billingInformations');
const printProvidersLens = monocle.Lens.fromProp('printProviders');
const selectedPrintProviderLens = monocle.Lens.fromPath(['step1', 'selectedPrintProvider']);
const featuresStatusLens = monocle.Lens.fromProp('featuresStatus');
const featuresLens = monocle.Lens.fromProp('features');
const featuresErrorLens = monocle.Lens.fromProp('featuresError');
const isMetaModalSaving = monocle.Lens.fromPath(['metaModal', 'isSaving']);
const metaModalError = monocle.Lens.fromPath(['metaModal', 'error']);
const methods = {};
exports.methods = methods;
methods[Actions.UPDATE_FIELD] = (state, action) => fp.function.compose(step1Lens.modify(updateFieldLens(action.payload.key, action.payload.value)), step1Lens
    .asOptional()
    .compose(step1ErrorsLens)
    .modify((x) => {
    delete x[action.payload.key];
    return x;
}))(state);
methods[Actions.CREATE_PROJECT] = (state, action) => fp.function.compose(step1Lens.compose(step1StatusLens).set('INITIAL'), savingLens.set('SAVING'))(state);
methods[Actions.CREATE_PROJECT_SUCCESS] = (state, action) => {
    return fp.function.compose(step1Lens.modify(step1ProjectLens.set({
        status: 'CREATED',
        project: action.payload.project
    })), step1Lens.modify(updateFieldLens('id', action.payload.project.id)), step1Lens.modify(updateFieldLens('type', action.payload.project.type)), savingLens.set('SAVED'))(state);
};
methods[Actions.CREATE_PROJECT_FAILED] = (state, action) => savingLens.set('FAILED')(state);
methods[Actions.UPDATE_WIZARD_STEP] = (state, action) => wizardStepLens.set(action.payload.step)(state);
methods[Actions.UPDATE_WIZARD_CUSTOMER] = (state, action) => changedCustomerLens.set(action.payload.customer)(state);
methods[Actions.CLEAR_STATE] = () => (Object.assign({}, exports.initialState));
methods[Actions.TOGGLE_CREATE] = (state) => metaLens.modify(metaModalStatusLens.set('CREATE'))(state);
methods[Actions.CLOSE_META_MODAL] = (state) => metaLens.modify(metaModalStatusLens.set('NONE'))(state);
methods[Actions.TOGGLE_EDIT] = (state, action) => metaLens.modify(fp.function.compose(metaModalValuesLens.set(step4Lens.get(state).metaMap[action.payload.uuid]), metaModalStatusLens.set('EDIT')))(state);
methods[Actions.SET_SELECTED_VALUE] = (state, action) => metaLens.modify(metaModalSelectedValueLens.set(action.payload.value))(state);
methods[Actions.INSERT_META] = (state) => fp.function.compose(isMetaModalSaving.set('SAVING'), metaModalError.set(undefined))(state);
methods[Actions.INSERT_META_SUCCESS] = (state) => fp.function.compose(metaLens.modify(metaModalStatusLens.set('NONE')), isMetaModalSaving.set('SAVED'), step4Lens.modify(metaListEditStatusLens.set('SAVED')), metaLens.modify(metaModalValuesLens.modify(optionsValuesLens.set([]))))(state);
methods[Actions.INSERT_META_VALIDATION] = (state, action) => fp.function.compose(isMetaModalSaving.set('FAILED'), metaModalError.set(action.payload.reduce((acc, item) => {
    acc[item.key] = [...(acc[item.key] || []), item.value];
    return acc;
}, {})))(state);
methods[Actions.INSERT_META_FAILED] = (state) => fp.function.compose(isMetaModalSaving.set('FAILED'), step4Lens.modify(metaListEditStatusLens.set('FAILED')))(state);
methods[Actions.DELETE_META_ELEMENT] = (state) => step4Lens.modify(metaDeleteStatusLens.set('DELETING'))(state);
methods[Actions.DELETE_META_ELEMENT_FAILED] = (state) => step4Lens.modify(metaDeleteStatusLens.set('FAILED'))(state);
methods[Actions.DELETE_META_ELEMENT_SUCCESS] = (state, action) => fp.function.compose(step4Lens.modify(fp.function.compose(metaDeleteStatusLens.set('DELETED'), metaListLens.modify((metaMap) => {
    delete metaMap[action.payload.uuid];
    return metaMap;
}))), metaLens.modify(metaModalStatusLens.set('NONE')))(state);
methods[Actions.SET_META_FIELD] = (state, action) => {
    return metaLens.modify(metaModalValuesLens.modify((prev) => {
        const values = Object.assign({}, prev);
        const key = action.payload.key;
        const value = action.payload.value;
        if (key.includes('.')) {
            const splitted = key.split('.');
            return monocle.Lens.fromProp(splitted[0]).modify((x) => {
                return monocle.Lens.fromProp(splitted[1]).set(value)(x || {});
            })(values);
        }
        if (key === 'type' &&
            value !== 'select' &&
            value !== 'dependant-select') {
            return fp.function.compose(setMetaField('options', undefined), setMetaField(key, value))(values);
        }
        return setMetaField(key, value)(values);
    }))(state);
};
methods[Actions.SET_META_OPTIONS_VALUE] = (state, action) => {
    if (action.payload.parent) {
        return metaLens.modify(metaModalValuesLens.modify(optionsValuesLens.modify((prev) => {
            const x = [...prev];
            return x.map((y) => {
                if (y.name ===
                    action.payload.parent.name) {
                    if (!y.options) {
                        y.options = [];
                    }
                    return Object.assign(Object.assign({}, y), { options: [...y.options].concat([action.payload.value]) });
                }
                return y;
            });
        })))(state);
    }
    return metaLens.modify(metaModalValuesLens.modify(optionsValuesLens.modify((x) => fp.function.concat(x, [action.payload.value]))))(state);
};
function swap(array, i, j) {
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
    array[i].order = i;
    array[j].order = j;
}
function quicksort(array, left, right) {
    left = left || 0;
    right = right || array.length - 1;
    const pivot = partition(array, left, right);
    if (left < pivot - 1) {
        quicksort(array, left, pivot - 1);
    }
    if (right > pivot) {
        quicksort(array, pivot - 1, right);
    }
    return array;
}
function partition(array, left, right) {
    const pivot = right;
    let i = left;
    let j = left;
    for (; j < right; j++) {
        if (array[j].order <= array[pivot].order) {
            swap(array, i, j);
            i++;
        }
    }
    swap(array, i, j);
    return i;
}
methods[Actions.UPDATE_META_OPTIONS_VALUE] = (state, action) => {
    if (!state.metaModal.values.options) {
        return state;
    }
    const { order, value } = action.payload.value;
    if (action.payload.parent) {
        return metaLens.modify(metaModalValuesLens.modify(optionsValuesLens.modify((prev) => {
            const x = [...prev];
            return x.map((y) => {
                if (action.payload.parent &&
                    y.value !== action.payload.parent.value) {
                    return y;
                }
                if (y.options) {
                    const idx = y.options.findIndex((f) => f.value === value);
                    if (idx > -1) {
                        swap(y.options, Math.max(0, Math.min(y.options.length - 1, order)), idx);
                        const sorted = quicksort(y.options, 0, y.options.length - 1);
                        return Object.assign(Object.assign({}, y), { options: sorted });
                    }
                }
                return y;
            });
        })))(state);
    }
    const idx = state.metaModal.values.options.findIndex((f) => f.value === value);
    swap(state.metaModal.values.options, Math.max(0, Math.min(state.metaModal.values.options.length - 1, order)), idx);
    const sorted = quicksort(state.metaModal.values.options, 0, state.metaModal.values.options.length - 1);
    return metaLens.modify(metaModalValuesLens.modify(optionsValuesLens.set(sorted)))(state);
};
methods[Actions.SET_RADIO_VALUE] = (state, action) => metaLens.modify(metaModalValuesLens.modify(optionsValuesLens.set([action.payload.value])))(state);
methods[Actions.DELETE_META_OPTIONS_VALUE] = (state, action) => {
    const { parent, value } = action.payload;
    const lookup = value.reduce((prev, c) => {
        prev[c.value] = true;
        return prev;
    }, {});
    if (parent) {
        return metaLens.modify(metaModalValuesLens.modify(optionsValuesLens.modify((x) => {
            return x.map((y) => {
                if (y.options) {
                    if (y.value === parent.value) {
                        const i = y.options.findIndex((f) => lookup[f.value]);
                        if (i === -1)
                            return y;
                        y.options.splice(i, 1);
                    }
                }
                return y;
            });
        })))(state);
    }
    return metaLens.modify(metaModalValuesLens.modify(optionsValuesLens.set(action.payload.value)))(state);
};
methods[Actions.FETCH_CUSTOMERS_SUCCESS] = (state, action) => {
    return customersLens.modify(fp.function.compose(customersValuesLens.set(action.payload.customers), customersStatusLens.set('FETCHED')))(state);
};
methods[Actions.VALIDATE_STEP_FAILURE] = (state, action) => fp.function.compose(step1Lens
    .asOptional()
    .compose(step1ErrorsLens)
    .set(action.payload.errors.reduce((rv, x) => {
    ;
    (rv[x.key] = rv[x.key] || []).push(x.value);
    return rv;
}, {})), step1Lens.compose(step1StatusLens).set('ERROR'), savingLens.set('STANDBY'))(state);
methods[Actions.VALIDATE_STEP_SUCCESS] = (state, action) => fp.function.compose(wizardStepLens.set(action.payload.wizardStep), step1Lens.compose(step1StatusLens).set('INITIAL'), step1Lens.asOptional().compose(step1ErrorsLens).set({}), savingLens.set('STANDBY'))(state);
//#region Billing informations
methods[Actions.TOGGLE_BILLING_INFORMATION_MODAL] = (state, action) => billingInformationsLens.modify((x) => {
    return Object.assign(Object.assign({}, x), { isOpen: !x.isOpen });
})(state);
methods[Actions.TOGGLE_EDIT_BILLING_INFORMATION_MODAL] = (state, action) => billingInformationsLens.modify((x) => {
    return Object.assign(Object.assign({}, x), { isOpen: true, selectedCustomer: action.payload });
})(state);
methods[Actions.REMOVE_BILLING_INFORMATION_CUSTOMER] = (state, action) => step1Lens.modify((x) => (Object.assign(Object.assign({}, x), { billingInformations: x.billingInformations.filter((x) => {
        if (x.type === 'CUSTOM' || action.payload.type === 'CUSTOM') {
            return true;
        }
        return x.customerNumber !== action.payload.customerNumber;
    }) })))(state);
methods[Actions.SEARCH_BILLING_INFORMATION_REQUEST] = (state, action) => billingInformationsLens.modify((x) => {
    switch (action.payload.type) {
        case 'customer': {
            return Object.assign(Object.assign({}, x), { fetchingCustomerStatus: 'FETCHING' });
        }
        case 'project': {
            return Object.assign(Object.assign({}, x), { fetchingProjectStatus: 'FETCHING' });
        }
        default:
            return x;
    }
})(state);
methods[Actions.SEARCH_BILLING_INFORMATION_SUCCESS] = (state, action) => billingInformationsLens.modify((x) => {
    switch (action.payload.type) {
        case 'customer': {
            return Object.assign(Object.assign({}, x), { fetchingCustomerStatus: 'FETCHED', customers: action.payload.list });
        }
        case 'project': {
            return Object.assign(Object.assign({}, x), { fetchingProjectStatus: 'FETCHED', projects: action.payload.list.reduce((res, item) => {
                    if (item.type === 'CUSTOM') {
                        return res;
                    }
                    return res.concat(item.projects || []);
                }, []) });
        }
        default:
            return x;
    }
})(state);
methods[Actions.SEARCH_BILLING_INFORMATION_FAILED] = (state, action) => billingInformationsLens.modify((x) => {
    switch (action.searchType) {
        case 'customer': {
            return Object.assign(Object.assign({}, x), { fetchingCustomerStatus: 'FAILED' });
        }
        case 'project': {
            return Object.assign(Object.assign({}, x), { fetchingProjectStatus: 'FAILED' });
        }
        default:
            return x;
    }
})(state);
methods[Actions.SELECT_BILLING_INFORMATION_CUSTOMER] = (state, action) => billingInformationsLens.modify((x) => {
    return Object.assign(Object.assign({}, x), { selectedCustomer: action.payload, selectedProjects: [], projects: [] });
})(state);
methods[Actions.SELECT_BILLING_INFORMATION_PROJECT] = (state, action) => {
    state = step1Lens.modify((x) => {
        const projectIds = action.payload.map((x) => x.projectNumber);
        const a = state.step1.billingInformations.reduce((arr, x) => {
            if (x.type === 'INTERNAL') {
                x.projects &&
                    x.projects.map((p) => {
                        if (projectIds.includes(p.projectNumber)) {
                            const projects = action.payload.map((x) => x);
                            x.projects = projects;
                        }
                    });
            }
            arr.push(x);
            return arr;
        }, []);
        return updateFieldLens('billingInformations', a)(x);
    })(state);
    return billingInformationsLens.modify((x) => {
        if (x.selectedCustomer === undefined) {
            return x;
        }
        return Object.assign(Object.assign({}, x), { selectedCustomer: Object.assign(Object.assign({}, x.selectedCustomer), { projects: action.payload }) });
    })(state);
};
methods[Actions.SET_BILLING_INFORMATIONS] = (state, action) => step1Lens.modify((x) => {
    const filtered = x.billingInformations.filter((y) => {
        if (y.type === 'CUSTOM' || action.payload.type === 'CUSTOM') {
            return true;
        }
        return y.customerNumber !== action.payload.customerNumber;
    });
    filtered.push(action.payload);
    return updateFieldLens('billingInformations', filtered)(x);
})(state);
methods[Actions.CLEAR_BILLING_INFORMATION_MODAL] = (state, action) => billingInformationsLens.set(Object.assign({}, billingInformationModalInitialState))(state);
//#endregion
methods[Actions.FETCH_PRINT_PROVIDER_SUCCESS] = (state, action) => {
    let s;
    const selected = action.payload.find((x) => (state.step1.selectedPrintProvider &&
        x.id === state.step1.selectedPrintProvider.id) ||
        false);
    if (selected) {
        s = selectedPrintProviderLens.set(selected)(state);
    }
    return printProvidersLens.set(action.payload)(s ? s : state);
};
methods[Actions.MODIFY_PROJECT_REQUEST] = (state) => fetchStatusLens.set('FETCHING')(state);
methods[Actions.MODIFY_PROJECT_FAILURE] = (state) => fetchStatusLens.set('FAILED')(state);
methods[Actions.SET_MODIFY_PROJECT] = (state, action) => fp.function.compose(fetchStatusLens.set('FETCHED'), step1Lens.modify((data) => {
    const { id, uuid, name, billingInformations, description, notes, projectId, projectStatus, projectType, notifyFollowing, salesRepresentive, printProvider, customer, customerSalesRepresentative, conversionService, author, template, type } = action.payload.project;
    const selectedPrintProvider = state.printProviders
        .filter((provider) => provider.id === printProvider)
        .pop();
    return Object.assign(Object.assign({}, data), { id: id, uuid: uuid, customer: customer, projectName: name, billingInformations: billingInformations || [], description: description || '', notes: notes || '', projectId,
        projectStatus,
        projectType,
        template, notifyFollowing: notifyFollowing || [], salesRepresentive: salesRepresentive || undefined, selectedPrintProvider: (printProvider && selectedPrintProvider) || undefined, customerSalesRepresentative,
        conversionService,
        author,
        type });
}))(state);
methods[Actions.DELETE_EDIT] = (state, action) => {
    const name = action.payload.name ? action.payload.name : '';
    return step3Lens.modify(fp.function.compose(step3ModalStatusLens.set(action.payload.mode), step3ModalNameLens.set(name), step3ModalIdLens.set(action.payload.id), step3ModalTypeLens.set(action.payload.type)))(state);
};
methods[Actions.DELETE_EDIT_SET_NAME] = (state, action) => step3Lens.modify(step3ModalNameLens.set(action.payload))(state);
methods[Actions.TOGGLE_MODAL] = (state, action) => step3Lens.modify(step3ModalLens.set(Object.assign({}, createEditInitialState)))(state);
//#endregion
methods[Actions.DELETE_EDIT_CATEGORY_FAILED] = (state, action) => step3Lens.modify(step3ModalStatusLens.set('FAILED'))(state);
methods[Actions.DELETE_EDIT_USER_GROUP_FAILED] = (state, action) => step3Lens.modify(step3ModalStatusLens.set('FAILED'))(state);
methods[Actions.FETCH_METAS] = (state) => step4Lens.modify(metaListStatusLens.set('FETCHING'))(state);
methods[Actions.FETCH_METAS_SUCCESS] = (state, action) => {
    const result = action.payload.metadata
        .sort((a, b) => a.order - b.order)
        .reduce((map, obj) => {
        map[obj.identifier] = obj;
        return map;
    }, {});
    return step4Lens.modify(fp.function.compose(metaSchemaIdLens.set(action.payload.id), metaListLens.set(result), metaListStatusLens.set('FETCHED')))(state);
};
methods[Actions.FETCH_METAS_FAILED] = (state) => step4Lens.modify(metaListStatusLens.set('FAILED'))(state);
//#endregion
methods[Actions.GET_SALES_REPRESENTIVE_REQUEST] = (state) => step1Lens.modify((data) => {
    return Object.assign(Object.assign({}, data), { customerSalesRepresentative: undefined, customerSalesRepresentativeStatus: 'FETCHING' });
})(state);
methods[Actions.GET_SALES_REPRESENTIVE_SUCCESS] = (state, action) => step1Lens.modify((data) => {
    return Object.assign(Object.assign({}, data), { customerSalesRepresentative: action.payload === null ? undefined : action.payload, customerSalesRepresentativeStatus: 'FETCHED' });
})(state);
methods[Actions.GET_SALES_REPRESENTIVE_FAILURE] = (state) => step1Lens.modify((data) => {
    return Object.assign(Object.assign({}, data), { customerSalesRepresentativeStatus: 'FAILED' });
})(state);
//#region features
methods[Actions.step1_features.FETCH_FEATURES_REQUEST] = (state) => step1Lens.modify(fp.function.compose(featuresErrorLens.set(undefined), featuresLens.set([]), featuresStatusLens.set('FETCHING')))(state);
methods[Actions.step1_features.FETCH_FEATURES_SUCCESS] = (state, action) => step1Lens.modify(fp.function.compose(featuresStatusLens.set('FETCHED'), featuresLens.set(action.payload.features)))(state);
methods[Actions.step1_features.FETCH_FEATURES_FAILED] = (state, action) => step1Lens.modify(fp.function.compose(featuresLens.set([]), featuresStatusLens.set('FAILED'), featuresErrorLens.set(action.payload.error)))(state);
methods[Actions.step1_features.COPY_ALL] = (state, action) => {
    return step1Lens.modify(fp.function.compose(featuresStatusLens.set('FETCHED'), featuresLens.set(action.payload.features)))(state);
};
methods[Actions.step1_features.SELECT] = (state, action) => {
    return step1Lens.modify(featuresLens.modify((items) => items.map((x) => {
        if (x.uuid === action.payload.feature.uuid) {
            return Object.assign(Object.assign({}, x), { enabled: true });
        }
        return x;
    })))(state);
};
methods[Actions.step1_features.UNSELECT] = (state, action) => {
    return step1Lens.modify(featuresLens.modify((items) => items.map((x) => {
        if (x.uuid === action.payload.feature.uuid) {
            return Object.assign(Object.assign({}, x), { enabled: false });
        }
        return x;
    })))(state);
};
methods[Actions.step1_features.UPDATE_PRICE] = (state, action) => {
    return step1Lens.modify(featuresLens.modify((items) => items.map((x) => {
        if (x.uuid === action.payload.uuid) {
            return Object.assign(Object.assign({}, x), { price: action.payload.price });
        }
        return x;
    })))(state);
};
methods[Actions.MOVE_META] = (state) => step4Lens.modify(metaListEditStatusLens.set('SAVING'))(state);
methods[Actions.MOVE_META_SUCCESS] = (state) => step4Lens.modify(metaListEditStatusLens.set('SAVED'))(state);
methods[Actions.MOVE_META_FAILED] = (state) => step4Lens.modify(metaListEditStatusLens.set('FAILED'))(state);
methods[Actions.ADD_META_ELEMENT] = (state) => {
    return fp.function.compose(step4Lens.modify(metaListEditStatusLens.set('SAVING')), metaModalError.set({}))(state);
};
//#endregion
const handleInvite = (action) => (state) => {
    const fn = exports.usergroupInviteReducer.methods[action.type];
    if (fn) {
        return step3Lens.compose(inviteLens).modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleMemberList = (action) => (state) => {
    const fn = exports.usergroupListReducer.methods[action.type];
    if (fn) {
        return step3Lens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleState = (action) => (state) => {
    const fn = methods[action.type];
    if (fn) {
        return fn(state, action);
    }
    return state;
};
function wizard(state, action) {
    return fp.function.compose(handleInvite(action), handleMemberList(action), handleState(action))(state);
}
exports.wizard = wizard;
//# sourceMappingURL=wizard.js.map